import firebase from 'firebase'
import firebaseui from 'firebaseui'

const config = {
/*
  apiKey: process.env.FB_API_KEY,
  authDomain: process.env.FB_AUTH_DOMAIN,
  databaseURL: process.env.FB_DATABASE_URL,
  storageBucket: process.env.FB_STORAGE_BUCKET,
  messagingSenderId: process.env.FB_MESSAGING_SENDER_ID,
*/

  apiKey: 'AIzaSyD0vXlxrpGU0gSW9iSfxPxa3-F_ViW3LNk',
  authDomain: 'activehoop.firebaseapp.com',
  databaseURL: 'https://activehoop.firebaseio.com',
  projectId: 'activehoop',
  storageBucket: 'activehoop.appspot.com',
  messagingSenderId: '883937132402'

// stg

  // apiKey: 'AIzaSyDSNl0WYEiB08f3DMFD_fllKKP6CnmmpgI',
  // authDomain: 'stg-activehoop.firebaseapp.com',
  // databaseURL: 'https://stg-activehoop.firebaseio.com',
  // projectId: 'stg-activehoop',
  // storageBucket: 'stg-activehoop.appspot.com',
  // messagingSenderId: '697859449072'

}

export const FBApp = firebase.initializeApp(config)
export const FBUIApp = new firebaseui.auth.AuthUI(firebase.auth(FBApp))



// WEBPACK FOOTER //
// ./src/helpers/firebaseConfig.js